import PersonalInfoEmergencyForm from './PersonalInfoEmergencyForm.component';

export default PersonalInfoEmergencyForm;
